module.exports = __webpack_public_path__ + "static/media/simpleClaimsPrimary.87791c0f.svg";